import { FileMetadataBase, IFileMetadataBase } from "./FileMetadataBase";

export class ContentItemFileMetadata extends FileMetadataBase implements IContentItemFileMetadata {
  contentItemTypeId?: string | undefined;
  filePath?: string | undefined;

  constructor(data?: IContentItemFileMetadata) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.contentItemTypeId = _data["contentItemTypeId"];
      this.filePath = _data["filePath"];
    }
  }

  static fromJS(data: any): ContentItemFileMetadata {
    data = typeof data === 'object' ? data : {};
    const result = new ContentItemFileMetadata();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["contentItemTypeId"] = this.contentItemTypeId;
    data["filePath"] = this.filePath;
    super.toJSON(data);
    return data;
  }
}

export interface IContentItemFileMetadata extends IFileMetadataBase {
  contentItemTypeId?: string | undefined;
  filePath?: string | undefined;
}